const { useMemo } = require("react");
const { ADMIN_LEVEL_ACCESS } = require("resources/constants/constData");

export const filteredAdmin = (role) => {

     return ADMIN_LEVEL_ACCESS.filter((i) => {
      return   role===i;
    }).length>0;

  };